import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton } from "@mui/material";
import axios from "../../utils/api";

const ImageUpload = () => {
  const [model, setModel] = useState("");
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    setPreview(selectedFile ? URL.createObjectURL(selectedFile) : null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!model || !file) {
      setMessage("Please enter model name and select an image.");
      return;
    }

    const formData = new FormData();
    formData.append("model", model);
    formData.append("image", file);

    try {
      const response = await axios.post("/upload-image", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      setMessage("Image uploaded successfully!");
      console.log("Server Response:", response.data);
    } catch (error) {
      console.error("Error uploading image:", error);
      setMessage("Failed to upload image.");
    }
  };

  const inputStyle = {
    width: "100%",
    boxSizing: "border-box",
    padding: "0.75rem 1rem",
    fontSize: "1rem",
    border: "1px solid #e2e8f0",
    borderRadius: 8,
    outline: "none",
    marginBottom: 16,
  };

  return (
    <div
      style={{
        position: "relative",
        minHeight: "100vh",
        overflow: "hidden",
        background:
          "radial-gradient(1200px 600px at 10% 0%, rgba(37, 99, 235, 0.10), rgba(255,255,255,0) 60%), radial-gradient(900px 450px at 90% 15%, rgba(16, 185, 129, 0.10), rgba(255,255,255,0) 55%), #ffffff",
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        padding: "24px 32px 48px",
        boxSizing: "border-box",
      }}
    >
      <IconButton
        onClick={() => navigate(-1)}
        style={{
          position: "absolute",
          top: 24,
          left: 24,
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          backdropFilter: "blur(10px)",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          color: "#4a4a4a",
          zIndex: 10,
        }}
      >
        <ArrowBackIcon />
      </IconButton>

      <div style={{ textAlign: "center", marginTop: 56, marginBottom: 32 }}>
        <h1
          style={{
            margin: 0,
            marginBottom: 8,
            fontSize: "1.85rem",
            fontWeight: 700,
            letterSpacing: "-0.5px",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          Upload Model Image
        </h1>
        <p
          style={{
            margin: 0,
            fontSize: "0.95rem",
            color: "#64748b",
            fontWeight: 400,
          }}
        >
          Add a model name and select an image to upload to AWS
        </p>
      </div>

      <div style={{ maxWidth: 420, margin: "0 auto" }}>
        <form
          onSubmit={handleSubmit}
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <label
            style={{
              display: "block",
              marginBottom: 8,
              fontSize: "0.875rem",
              fontWeight: 500,
              color: "#64748b",
            }}
          >
            Model name
          </label>
          <input
            type="text"
            placeholder="Enter model name"
            value={model}
            onChange={(e) => setModel(e.target.value)}
            style={inputStyle}
          />

          <label
            style={{
              display: "block",
              marginBottom: 8,
              fontSize: "0.875rem",
              fontWeight: 500,
              color: "#64748b",
            }}
          >
            Image file
          </label>
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            style={{
              marginBottom: 16,
              fontSize: 14,
              color: "#64748b",
            }}
          />

          {preview && (
            <img
              src={preview}
              alt="Preview"
              style={{
                width: "100%",
                maxHeight: 240,
                objectFit: "contain",
                borderRadius: 8,
                border: "1px solid #e2e8f0",
                marginBottom: 16,
              }}
            />
          )}

          <button
            type="submit"
            style={{
              width: "100%",
              padding: "0.75rem 1rem",
              fontSize: "1rem",
              fontWeight: 600,
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              cursor: "pointer",
              boxShadow: "0 2px 8px rgba(102, 126, 234, 0.3)",
            }}
          >
            Upload
          </button>
        </form>

        {message && (
          <p
            style={{
              marginTop: 16,
              fontSize: "0.9rem",
              fontWeight: 500,
              color: message.includes("success") ? "#16a34a" : "#dc2626",
            }}
          >
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

export default ImageUpload;
